define("Mad_Utils/js/mixins/lib/mage/url/ensure-set-base-url",[],(function(){"use strict";return function(e){return window.BASE_URL&&e.setBaseUrl(window.BASE_URL),e}}));
